import { getCookie } from 'helper/cookie'
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { getTaskProgress } from 'api/Overview/overview'
import { InboxOutlined, RightOutlined } from '@ant-design/icons'
import { Progress, Row } from 'antd'
import { useHistory } from 'react-router'
const ContainerTask = styled.div``
const Container = styled.div``
const LayoutDetail = styled.div``
const ContainerSubtask = styled.div``

const color = {
  no_procent: '#f5f5f5',
  percent_0: '#f5f5f5',
  percent_50: '#FF6258',
  percent_75: '#FFAF00',
  percent_100: '#19D895',
}
const initalState = {
  data: [],
  isLoading: true,
}
const TaskProgress = (props) => {
  const { project_id, project_status_id } = props
  const [dataTask, setDataTask] = useState(initalState.data)
  const token = getCookie('access_token_admin')
  const [collaps, setCollaps] = useState(false)
  const [idCollaps, setIdCollaps] = useState()
  const history = useHistory()
  const getDataTaskProgress = async () => {
    await getTaskProgress({
      id: project_id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataTask([])
          return true
        }
        if (status === 200) {
          await setDataTask(data.progress)
        } else {
          return true
        }
      })
      .catch((error) => {
        setDataTask([])
        console.error(error)
      })
  }
  const goTaskBoxDetail = (id) => {
    if (project_status_id === 6) {
      history.push(`/taskinbox/${project_id}/${id}/update`)
    }

  }

  useEffect(() => {
    if (token) {
      getDataTaskProgress()
    }
  }, [token])
  const ContainerState = () => {
    if (dataTask !== null) {
      return (
        <div className="sub-container-scroll">
          {dataTask?.map((val) => {
            return (
              <div>
                <ContainerTask className="sub-container-task ">
                  <LayoutDetail className="layout-detail grid-container-taskprogress">
                    <Row className="title-task">
                      <RightOutlined
                        className={`rightOutlined ${val.child ? 'icon' : 'active-icon'}
                         ${val.child && collaps && idCollaps === val.sprintflow_id
                            ? 'active-right'
                            : 'right'
                          }`}
                        onClick={() => {
                          val.child && collaps && idCollaps === val.sprintflow_id
                            ? setCollaps(false)
                            : setCollaps(true),
                            setIdCollaps(val.sprintflow_id)
                        }}
                      />
                      <span
                        className="text-title-task small cutter-text-line-1"
                        style={{ cursor: 'pointer' }}
                        onClick={() => goTaskBoxDetail(val.sprintflow_id)}
                      >
                        {val.title}
                      </span>
                    </Row>
                    <Row className="progress-container-overview">
                      <Progress
                        className="progress-bar"
                        percent={val.percent_done}
                        size="small"
                        strokeColor={
                          val.percent_done < 75 && val.percent_done !== 0
                            ? color.percent_50
                            : val.percent_done === 100
                              ? color.percent_100
                              : val.percent_done === 0
                                ? color.percent_0
                                : color.percent_75
                        }
                      />
                      <span
                        className={`small ${val.percent_done < 75 && val.percent_done !== 0
                          ? 'percent-deley'
                          : val.percent_done === 100
                            ? 'percent-done'
                            : val.percent_done === 0
                              ? 'percent-zero'
                              : 'percent-todo'
                          }`}
                      >
                        {val.percent_done} %
                      </span>
                    </Row>
                  </LayoutDetail>
                </ContainerTask>
                <div
                  key={val.sprintflow_id}
                  className={
                    collaps && idCollaps === val.sprintflow_id
                      ? 'active-collaps'
                      : 'collaps'
                  }
                >
                  {val.child?.map((val_subtask) => (
                    <ContainerSubtask className="container-subtask">
                      <div className="grid-container-taskprogress">
                        <Row className="title-subtask">
                          <div className="circle"></div>
                          <span
                            className="text-title small cutter-text-line-1"
                            style={{ cursor: 'pointer' }}
                            onClick={() => goTaskBoxDetail(val_subtask.sprintflow_id)}
                          >
                            {val_subtask.title}
                          </span>
                        </Row>

                        <div className="progress-container-overview">
                          <Progress
                            className="progress-bar"
                            percent={val_subtask.percent_done}
                            size="small"
                            strokeColor={
                              val_subtask.percent_done < 75 &&
                                val_subtask.percent_done !== 0
                                ? color.percent_50
                                : val_subtask.percent_done === 100
                                  ? color.percent_100
                                  : val_subtask.percent_done === 0
                                    ? color.percent_0
                                    : color.percent_75
                            }
                          />
                          <span
                            className={`small ${val_subtask.percent_done < 75 &&
                              val_subtask.percent_done !== 0
                              ? 'percent-deley'
                              : val_subtask.percent_done === 100
                                ? 'percent-done'
                                : val_subtask.percent_done === 0
                                  ? 'percent-zero'
                                  : 'percent-todo'
                              }`}
                          >
                            {val_subtask.percent_done} %
                          </span>
                        </div>
                      </div>
                    </ContainerSubtask>
                  ))}
                </div>
              </div>
            )
          })}
        </div>
      )
    } else {
      return (
        <div className="sub-container-scroll">
          <div className="emytystate edit-height-emptystate">
            <InboxOutlined className="inbox" />
            <p>No Task</p>
          </div>
        </div>
      )
    }
  }
  return (
    <Container className="task-progress">
      <h3>Task Progress</h3>
      {ContainerState()}
    </Container>
  )
}

export default TaskProgress
